import { useRouterState } from '@tanstack/react-router'

export default function useIsRouteCached(routeId: string) {
	const routerState = useRouterState()
	const isRouteCached = routerState.cachedMatches.some((item) => item.routeId === routeId)
	return isRouteCached
}
